import { comprobanteService } from '../../services/comprobanteService';
import type { ComprobanteResumen } from '../../types/comprobante';

/**
 * PDF: la pestaña se abre en el mismo clic (si se abre después de esperar el enlace, el navegador la
 * bloquea como ventana emergente) y recibe el enlace temporal cuando llega.
 */
export async function abrirPdfEnPestanaNueva(comprobante: ComprobanteResumen): Promise<void> {
  const pestana = window.open('about:blank', '_blank');
  try {
    if (!pestana) throw new Error('Tu navegador bloqueó la pestaña nueva. Permite ventanas emergentes para este sitio.');
    const [url] = await comprobanteService.firmarRutas(comprobante.rutas);
    pestana.opener = null;
    pestana.location.href = url;
  } catch (e: unknown) {
    pestana?.close();
    throw e;
  }
}
